import styled from '@emotion/styled';
import {colors} from './config';
import {Error} from 'ui';

import on from 'assets/img/on.svg';
import off from 'assets/img/off.svg';

export const checkboxStyle = {
  display: 'flex',
  height: 32,
  width: 32,
  minWidth: 32,
  marginRight: 8,
  marginLeft: 0,
  cursor: 'pointer',
};

export const InputField = styled('input')(({color, hasError}) => ({
  display: 'flex',
  border: `1px solid ${colors.white}`,
  borderColor: hasError ? '#D80B0B' : color === 'white' ? colors.white : 'rgba(121, 124, 132, 0.23)',
  backgroundColor: 'transparent',
  height: 49,
  // width: 296,
  color: color === 'white' ? colors.white : colors.black,
  borderRadius: 4,
  marginTop: 6,
  paddingLeft: 20,
  paddingRight: 20,
  outline: 0,
  '&:focus': {
    backgroundColor: color === 'white' ? 'rgba(0, 0, 0,0.1)' : colors.white,
  },
}));

export const InputCheckbox = styled(({...p}) => <input type="checkbox" {...p} />)({
  position: 'absolute',
  appearance: 'none',
  cursor: 'pointer',
});

export const CheckBox = styled('div')({
  ...checkboxStyle,
  backgroundImage: `url(${off})`,
});

export const Checked = styled('div')({
  ...checkboxStyle,
  backgroundImage: `url(${on})`,
});

export const Label = styled('label')(({color}) => ({
  display: 'flex',
  color: color === 'white' ? colors.white : colors.black,
  fontSize: 14,
  lineHeight: '16px',
  cursor: 'pointer',
}));

export const LabelGrey = styled(Label)({
  color: colors.grey,
  lineHeight: '22px',
});

export const LabelDark = styled(Label)({
  color: colors.black,
});

export const CheckboxLabel = styled('label')({
  display: 'flex',
  alignItems: 'center',
  color: colors.caramel,
  fontSize: 12,
  lineHeight: '16px',
});

export const Select = styled(({id, label, error, value, options, onChange, ...p}) => (
  <div {...p}>
    {label && <Label htmlFor={id}>{label}</Label>}
    <select id={id} value={value} onChange={onChange}>
      {Object.keys(options).map(key => (
        <option value={key} key={key}>
          {options[key]}
        </option>
      ))}
    </select>
    {error && <Error>{error}</Error>}
  </div>
))({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 18,
  width: '100%',
});

export const TextInput = styled(({id, label, error, hasError, value, onChange, color, type, disabled, ...p}) => (
  <div {...p}>
    {label && (
      <Label color={color} htmlFor={id}>
        {label}
      </Label>
    )}
    <InputField
      color={color}
      hasError={hasError}
      type={type}
      id={id}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
    {error && <Error>{error}</Error>}
  </div>
))({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 18,
  width: '100%',
});

export const Checkbox = styled(({id, label, error, value, onChange, ...p}) => (
  <div {...p}>
    <CheckboxLabel htmlFor={id}>
      <InputCheckbox id={id} value={!!value} onChange={onChange} />
      {value ? <Checked value={value} /> : <CheckBox value={value} />}
      {label}
    </CheckboxLabel>

    {error && <Error>{error}</Error>}
  </div>
))({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 8,
  marginTop: 0,
  cursor: 'pointer',
});

export const FieldContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginBottom: 50,
});

export const Radio = styled('div')({
  display: 'flex',
  width: 23,
  height: 23,
  minWidth: 23,
  border: '1px solid rgba(121, 124, 132, 0.23)',
  borderRadius: '50%',
  marginRight: 16,
});

export const RadioChecked = styled(Radio)({
  backgroundColor: colors.darkBrown,
});

export const RadInput = styled(({...p}) => <input type="radio" {...p} />)({
  position: 'absolute',
  appearance: 'none',
  width: 23,
  height: 23,
  minWidth: 23,
  cursor: 'pointer',
});

export const RadioContainer = styled('label')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  padding: 13,
  border: '1px solid rgba(121, 124, 132, 0.23)',
  borderRadius: 4,
  cursor: 'pointer',
  '&:nth-of-type(1)': {
    marginRight: 14,
  },
});

export const RowContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
});

export const RadioInput = styled(({label, error, id, value1, value2, value, onChange, name, ...p}) => (
  <div onChange={onChange} {...p}>
    <RowContainer>
      <RadioContainer htmlFor={`${id}_1`}>
        <RadInput name={name} value={value1} onChange={onChange} id={`${id}_1`} />
        {value === value1 ? (
          <RadioChecked name={name} value={value1} onChange={onChange} id={`${id}_1`} />
        ) : (
          <Radio name={name} value={value1} onChange={onChange} id={`${id}_1`} />
        )}
        {label && <LabelGrey htmlFor={`${id}_1`}>{value1}</LabelGrey>}
      </RadioContainer>

      <RadioContainer htmlFor={`${id}_2`}>
        <RadInput name={name} value={value2} onChange={onChange} id={`${id}_2`} />
        {value === value2 ? (
          <RadioChecked name={name} value={value2} onChange={onChange} id={`${id}_2`} />
        ) : (
          <Radio name={name} value={value2} onChange={onChange} id={`${id}_2`} />
        )}
        {label && <LabelGrey htmlFor={`${id}_2`}>{value2}</LabelGrey>}
      </RadioContainer>
    </RowContainer>
    {error && <Error>{error}</Error>}
  </div>
))({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 10,
  marginBottom: 16,
  width: '100%',
});

export const FormContainer = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  paddingBottom: 50,
});

export const InputsContainer = styled('div')({
  display: 'flex',
  width: '100%',
  'div:nth-of-type(1)': {
    marginRight: 14,
  },
  div: {
    flex: 1,
    width: '45%',
  },
});
